import { PaymentAddressSettingsInterface } from '@pe/checkout/types';


export const HAS_NODE_FORM_OPTIONS = true;

export const BILLING_ADDRESS_SETTINGS: PaymentAddressSettingsInterface = null;
